import 'vuetify/styles';
import { createVuetify } from 'vuetify';

// Import only the components you actually use for tree-shaking
import {
  VAlert,
  VApp,
  VAppBar,
  VAutocomplete,
  VAvatar,
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VCardSubtitle,
  VCheckbox,
  VChip,
  VCol,
  VContainer,
  VDatePicker,
  VDialog,
  VDivider,
  VFabTransition,
  VForm,
  VHover,
  VIcon,
  VImg,
  VList,
  VListItem,
  VListItemTitle,
  VListItemSubtitle,
  VMenu,
  VProgressCircular,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VRow,
  VSelect,
  VSkeletonLoader,
  VSlideXTransition,
  VSlideYTransition,
  VSnackbar,
  VSpacer,
  VSwitch,
  VTextarea,
  VTextField,
  VToolbar,
  VToolbarTitle,
  VTooltip,
} from 'vuetify/components';

export default createVuetify({
  components: {
    VAlert,
    VApp,
    VAppBar,
    VAutocomplete,
    VAvatar,
    VBtn,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VCardSubtitle,
    VCheckbox,
    VChip,
    VCol,
    VContainer,
    VDatePicker,
    VDialog,
    VDivider,
    VFabTransition,
    VForm,
    VHover,
    VIcon,
    VImg,
    VList,
    VListItem,
    VListItemTitle,
    VListItemSubtitle,
    VMenu,
    VProgressCircular,
    VProgressLinear,
    VRadio,
    VRadioGroup,
    VRow,
    VSelect,
    VSkeletonLoader,
    VSlideXTransition,
    VSlideYTransition,
    VSnackbar,
    VSpacer,
    VSwitch,
    VTextarea,
    VTextField,
    VToolbar,
    VToolbarTitle,
    VTooltip,
  },
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#047481',
          secondary: '#6c7280',
          accent: '#6c8294',
          neutral: '#f5f5f5',
          anchor: '#047481',
          contrast: '#2c7a91',
          contrastMuted: '#507983',
        },
      },
    },
  },
});
